import styled from 'styled-components'

import { ArrowDirectionIcon } from '@application/Interfaces/Icons'

export const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 30px 15px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 30px 50px;
    }
`

export const Button = styled.button`
    display: flex;
    align-items: center;
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.p500};
    background-color: transparent;

    &:disabled {
        color: ${(props) => props.theme.color.g500};

        svg path {
            stroke: ${(props) => props.theme.color.g500};
        }
    }
`

export const Text = styled.span`
    display: none;
    padding-left: 8px;
    padding-right: 8px;
    text-transform: uppercase;

    @media ${(props) => props.theme.query.min.tablet} {
        display: block;
    }
`

export const Arrow = styled(ArrowDirectionIcon)`
    width: 40px;
    height: 28px;

    path {
        stroke: ${(props) => props.theme.color.p500};
    }

    @media ${(props) => props.theme.query.min.tablet} {
        width: 16px;
        height: 11px;
    }
`
